import { Button, Col, Image, message, Row, Typography, Input, Card } from "antd";
import React from "react";
import { connect } from "react-redux";
import {
  createArticle,
  getArticles,
  regenerateArticle,
  updateArticle,
  uploadThumnail,
} from "../../RestServices/videosService";
import Pagination from "../Pagination";
import Table from "../Table";

import { ThumbDown, ThumbUp } from "@material-ui/icons";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import { NewsEnum } from "../../shared";
import { MAIN_BACKGROUND_COLOR } from "../../styleConstants";
import ContantTitle from "../../utils/contantTitle/ContantTitle";
import Calendar from "../../utils/dropDown/Calendar";
import CategoryDropDown from "../../utils/dropDown/CategoryDropDown";
import DeleteVideo from "../UiElements/DeleteVideo";
import AddArticlesScreen from "./AddArticlesScreen";
import moment from "moment";

// Dynamic Score Calculators for Production-grade Health & SEO Grading
const calculateSeoScore = (video) => {
  // If the exact score was already saved in DB, use it directly!
  if (video.seoScore !== undefined && video.seoScore !== null && video.seoScore !== 0) {
    return video.seoScore;
  }

  let score = 20;
  const focusKeyword = video.focusKeyword || "";
  const metaTitle = video.metaTitle || video.title || "";
  const metaDescription = video.metaDescription || video.shortDescription || "";
  const slug = video.permalink || "";
  
  // Lean fallback for word count on list view (excludes description)
  const isRichShortDesc = metaDescription && metaDescription.length > 50;

  if (focusKeyword && metaTitle.toLowerCase().includes(focusKeyword.toLowerCase())) score += 20;
  if (metaDescription && metaDescription.length >= 110 && metaDescription.length <= 160) score += 20;
  if (isRichShortDesc) score += 20;
  if (focusKeyword && slug.toLowerCase().includes(focusKeyword.toLowerCase().replace(/\s+/g, "-"))) score += 20;
  return Math.min(100, score);
};

const calculateHealthScore = (video) => {
  // If the exact score was already saved in DB, use it directly!
  if (video.healthScore !== undefined && video.healthScore !== null && video.healthScore !== 0) {
    return video.healthScore;
  }

  const descriptionText = video.description || "";
  
  // If we are looking at a lean list view (where description is excluded/empty),
  // we run an extremely smart fallback using other available fields!
  if (!descriptionText) {
    let score = 20;
    const hasShortDesc = video.shortDescription && video.shortDescription.length > 30;
    const hasImage = video.articleImage && video.articleImage.length > 0;
    const hasKeyword = !!video.focusKeyword;

    if (/\d+/.test(video.title || "") || /\d+/.test(video.shortDescription || "")) {
      score += 15;
    }
    if (hasImage) {
      score += 20;
    }
    if (hasKeyword) {
      score += 15;
    }
    if (hasShortDesc) {
      score += 15;
    }
    if (video.pageCategory && video.pageCategory.length > 0) {
      score += 15;
    }
    return Math.min(100, score);
  }

  // If full description is present (e.g., loaded dynamically), run complete calculation
  let score = 20;
  const sources = video.sources || [];
  const takeaways = video.takeaways || [];
  const faqs = video.faqs || [];

  if (/\d+/.test(descriptionText)) {
    score += 15;
  }
  if (descriptionText.includes("<table>") || descriptionText.includes("<tr>") || /\|[-:]+\|/.test(descriptionText)) {
    score += 20;
  }
  const hasReferences = (sources && sources.length > 0) || 
                        descriptionText.toLowerCase().includes("reference") || 
                        descriptionText.toLowerCase().includes("source") || 
                        descriptionText.includes("http://") || 
                        descriptionText.includes("https://");
  if (hasReferences) {
    score += 15;
  }
  const hasStructure = descriptionText.includes("<h2>") || 
                       descriptionText.includes("<h3>") || 
                       descriptionText.includes("<h4>") || 
                       descriptionText.includes("##") || 
                       descriptionText.includes("<ul>") || 
                       descriptionText.includes("<ol>");
  if (hasStructure) {
    score += 15;
  }
  if ((takeaways && takeaways.length > 0) || (faqs && faqs.length > 0)) {
    score += 15;
  }

  return Math.min(100, score);
};

const styles = {
  tableContainer: {
    display: "flex",
    justifyContent: "center",
  },
  addVideoButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  addVideoButton: {
    marginRight: "20px",
    backgroundColor: MAIN_BACKGROUND_COLOR,
    color: "white",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    padding: "5px",
  },
  titleContainer: {
    padding: "10px 20px",
    color: "#fb6222",
  },
};

// LIKE", "CLAP", "ANGRY"
const columns = [
  {
    Header: (
      <div>
        <p style={{ margin: 0, padding: 0 }}>Sr.</p>
        <p style={{ margin: 0, padding: 0, color: "black" }}>Date/Time</p>
      </div>
    ),
    accessor: "_id",
  },
  {
    Header: "Images",
    accessor: "image",
  },
  {
    Header: (
      <div>
        <p style={{ margin: 0, padding: 0 }}>title</p>
        <p style={{ margin: 0, padding: 0, color: "black" }}>discription</p>
      </div>
    ),
    accessor: "title",
  },

  {
    Header: "Status",
    accessor: "reactions",
  },
  {
    Header: "Views",
    accessor: "views",
  },
  {
    Header: "articleType",
    accessor: "articleType",
  },
  {
    Header: "Action",
    accessor: "action",
  },
];

class Body extends React.Component {
  constructor() {
    super();
    this.state = {
      isFormLoading: false,
      isEditFormLoading: false,
      uploadedPercentage: 0,
      videos: [],
      isModalEdit: false,
      isModalOpen: false,
      videoId: "",
      searchQuery: "",
      title: "",
      editData: {},
      typingTimeout: 0,
      shortDescription: "",
      description: "",
      video: null,
      descriptionWithImage: [{ paragraph: "", imageUrl: "", image: "" }],
      thumbnail: null,
      totalPages: 0,
      tags: [],
      currentPage: 1,
      thumbnailUrl: "",
      playingVideo: null,
      isVideoPlayerOpen: false,
      selectedCategory: "",
      getArticlesFilterCategory: "",
      statusFilter: "", // "" means All, "Published" means Published, "Draft" means Drafts
      province: "پنجاب",
      text: "",
      main: true,
      regeneratingId: null,
      draftsCount: 0,
      isPreviewOpen: false,
      previewImageUrl: "",
    };
  }

  // Open an existing article inside the AI Article editor with all its content
  // pre-filled. Fetches the full document (the list only carries lean fields).
  editInAIArticle = async (articleId) => {
    if (!articleId) return;
    if (!this.props.setSelected) {
      message.error("AI editor navigation is not available here.");
      return;
    }
    try {
      const data = await getArticles(
        { articleId },
        this.props.Auth.user.token,
      );
      const fullArticle = data?.articles?.docs?.[0];
      if (!fullArticle) {
        message.error("Could not load the article to edit.");
        return;
      }
      // Navigate to the AI Article tab, passing the full article as data.
      this.props.setSelected("AI_Article", "", fullArticle);
    } catch (err) {
      message.error(err?.response?.data?.message || err.message || "Failed to open article in AI editor.");
    }
  };

  // Per-row Update: regenerate a single article's content by its id.
  // Scoped to one article — never touches the other rows.
  regenerateOneArticle = async (articleId) => {
    if (!articleId) return;
    const confirmed = window.confirm(
      "Regenerate this article's content with AI? This overwrites its current text for this article only.",
    );
    if (!confirmed) return;

    this.setState({ regeneratingId: articleId });
    try {
      const res = await regenerateArticle(
        { articleId },
        this.props.Auth.user.token,
      );
      if (res && res.success) {
        message.success("Article regenerated successfully!");
        await this.getArticles(this.state.currentPage);
      } else {
        message.error(res?.error || "Regeneration failed.");
      }
    } catch (err) {
      message.error(err?.response?.data?.message || err.message || "Regeneration failed.");
    } finally {
      this.setState({ regeneratingId: null });
    }
  };

  onAddCategoryChange = (selectedCategory) =>
    this.setState({ selectedCategory });

  openVideoPlayer = () => this.setState({ isVideoPlayerOpen: true });
  closeVideoPlayer = () => this.setState({ isVideoPlayerOpen: false });
  openVideoForm = () => {
    this.setState({
      text: "Add",
      editData: {},
      main: !this.state.main,
    });
    this.getArticles(this.state.currentPage);
  };
  closeVideoForm = () => this.setState({ isModalOpen: false });
  closeVideoEditFrom = () =>
    this.setState({ isModalEdit: false, title: "", description: "", tags: [] });
  inputChangeHandler = (evt, textNmae) => {
    const { name, value } = evt.target;
    if (name) {
      this.setState({ [name]: value });
    } else {
      this.setState({ [textNmae]: value });
    }
  };

  inputChangeDiscription = (description, index) => {
    const { descriptionWithImage } = this.state;
    descriptionWithImage[index].paragraph = description;
    this.setState({ descriptionWithImage });
  };

  selectVideo = (video) => this.setState({ video });
  selectThumbnail = (thumbnail) => this.setState({ thumbnail });

  onVideoCategoryChange = (getArticlesFilterCategory) =>
    this.setState({ getArticlesFilterCategory }, this.getArticles);

  submitVideo = async () => {
    const {
      title,
      description,
      shortDescription,
      thumbnailUrl,
      selectedCategory,
      descriptionWithImage,
    } = this.state;
    if (
      !title ||
      !shortDescription ||
      !thumbnailUrl ||
      !selectedCategory ||
      !descriptionWithImage
    ) {
      return message.warn("Please fill all the required Fields");
    }
    this.setState({ isFormLoading: true });

    try {
      await createArticle(
        {
          title,
          shortDescription,
          thumbnail: thumbnailUrl,
          articleType: selectedCategory,
          descriptionWithImage: descriptionWithImage,
          status: "Published",
        },
        this.props.Auth.user.token,
        (percentage) => this.setState({ uploadedPercentage: percentage }),
      );
      this.resetForm();
      message.success("Article Successfully Uploaded");
      this.getArticles(1);
    } catch (err) {
      this.setState({ isFormLoading: false });
      if (err.response) {
        return message.error(err.response.data.message);
      }
      return message.error(err.message);
    }
  };

  uploadThumbnail = async (thumbnail) => {
    this.setState({ isFormLoading: true });
    // const { thumbnail } = this.state;
    const formData = new FormData();

    formData.append("thumbnail", thumbnail);

    try {
      const response = await uploadThumnail(
        formData,
        this.props.Auth.user.token,
        (percentage) => this.setState({ uploadedPercentage: percentage }),
      );
      this.setState({
        isFormLoading: false,
        thumbnailUrl: response.thumbnailUrl,
      });
    } catch (err) {
      this.setState({ isFormLoading: false });
      if (err.response) {
        return message.error(err.response.data.message);
      }
      return message.error(err.message);
    }
  };

  uploadThumbnailofParagraph = async (thumbnail, index) => {
    this.setState({ isFormLoading: true });
    // const { thumbnail } = this.state;
    const formData = new FormData();

    formData.append("thumbnail", thumbnail);

    try {
      const response = await uploadThumnail(
        formData,
        this.props.Auth.user.token,
        (percentage) => this.setState({ uploadedPercentage: percentage }),
      );
      const { descriptionWithImage } = this.state;
      descriptionWithImage[index].imageUrl = response.thumbnailUrl;
      descriptionWithImage[index].image = response.thumbnail;

      this.setState({ descriptionWithImage, isFormLoading: false });
    } catch (err) {
      this.setState({ isFormLoading: false });
      if (err.response) {
        return message.error(err.response.data.message);
      }
      return message.error(err.message);
    }
  };

  removeThumbnailofParagraph = (index) => {
    const { descriptionWithImage } = this.state;
    descriptionWithImage[index].imageUrl = "";
    this.setState({ descriptionWithImage });
  };

  videoEditSubmit = async () => {
    this.setState({ isEditFormLoading: true });
    const {
      title,
      descriptionWithImage,
      tags,
      videoId,
      thumbnailUrl,
      selectedCategory,
      shortDescription,
    } = this.state;

    try {
      await updateArticle(
        {
          title,
          descriptionWithImage,
          articleType: selectedCategory,
          thumbnail: thumbnailUrl,
          shortDescription,
          articleId: videoId,
          status: "Published",
        },
        this.props.Auth.user.token,
        (percentage) => this.setState({ uploadedPercentage: percentage }),
      );
      this.resetForm();
      message.success("Article Successfully Uploaded");
      this.getArticles(this.state.currentPage + 1 ?? 1);
    } catch (err) {
      this.getArticles(this.state.currentPage + 1 ?? 1);

      this.setState({ isEditFormLoading: false });
      if (err.response) {
        return message.error(err.response.data.message);
      }
      return message.error(err.message);
    }
  };
  resetForm = () =>
    this.setState({
      title: "",
      description: "",
      video: null,
      isFormLoading: false,
      isModalOpen: false,
      isEditFormLoading: false,
      descriptionWithImage: [{ paragraph: "", imageUrl: "", image: "" }],

      uploadedPercentage: 0,
      isModalEdit: false,
    });

  getArticles = async (pageNo) => {
    try {
      const data = await getArticles(
        {
          articleType: this.state.getArticlesFilterCategory,
          pageNo,
          searchQuery: this.state.searchQuery,
          status: this.state.statusFilter || "Published",
        },
        this.props.Auth.user.token,
      );
      const videos = data.articles.docs.map((video, index) => ({
        // serialNumber: `${video?.sr}`,
        _id: (
          <div>
            <p>{video?.sr}</p>
            <p>{moment(new Date(video.publishedAt)).format("MMM DD YY")} </p>
          </div>
        ),
        title: (
          <div style={{ width: "300px" }}>
            <Typography.Paragraph
              ellipsis={{
                rows: 3,
                tooltip: <span> {video.title}</span>,
              }}
              type="warning"
              style={{ textDecoration: "underline", fontSize: "14px" }}
            >
              {video.title}
            </Typography.Paragraph>

            <Typography.Paragraph
              ellipsis={{
                rows: 4,
                tooltip: <span> {video.shortDescription}</span>,
              }}
              style={{ textDecoration: "underline", fontSize: "14px" }}
            >
              {video.shortDescription}
            </Typography.Paragraph>
          </div>
        ),

        articleType: (
          <div>
            <Typography.Text style={{ fontSize: "14px", color: "black" }}>
              {video.pageCategory ?? "Not assign yet"} / {video.articleType}
            </Typography.Text>
          </div>
        ),

        views: (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", fontSize: "14px", fontWeight: "bold", color: "#1e293b" }}>
            {video.totalViews ?? 0}
          </div>
        ),
        reactions: (() => {
          const healthScore = calculateHealthScore(video);
          const seoScore = calculateSeoScore(video);

          const getScoreColor = (score) => {
            if (score >= 80) return "#10b981"; // Emerald Green
            if (score >= 50) return "#fb923c"; // Vivid Orange
            return "#ef4444"; // Premium Red
          };

          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                justifyContent: "center",
                alignItems: "stretch",
                padding: "10px 14px",
                backgroundColor: "#f8fafc",
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                minWidth: "145px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.02)"
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>
                <span style={{ fontSize: "13px", fontWeight: "700", color: "#475569" }}>Health:</span>
                <span style={{ 
                  fontSize: "13px", 
                  fontWeight: "800", 
                  color: getScoreColor(healthScore),
                  backgroundColor: getScoreColor(healthScore) + "12",
                  padding: "4px 8px",
                  borderRadius: "5px"
                }}>
                  {healthScore}%
                </span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>
                <span style={{ fontSize: "13px", fontWeight: "700", color: "#475569" }}>SEO:</span>
                <span style={{ 
                  fontSize: "13px", 
                  fontWeight: "800", 
                  color: getScoreColor(seoScore),
                  backgroundColor: getScoreColor(seoScore) + "12",
                  padding: "4px 8px",
                  borderRadius: "5px"
                }}>
                  {seoScore}%
                </span>
              </div>
            </div>
          );
        })(),
        image: (
          <div 
            onClick={() => this.setState({ isPreviewOpen: true, previewImageUrl: video?.articleImage[0]?.url })}
            style={{ cursor: "pointer", position: "relative", width: "80px", height: "45px" }}
          >
            <img
              style={{ 
                width: "80px", 
                height: "45px", 
                borderRadius: "6px", 
                objectFit: "cover",
                boxShadow: "0 2px 5px rgba(0,0,0,0.08)",
                border: "1px solid #e2e8f0"
              }}
              src={video?.articleImage[0]?.url}
              alt={video.title}
            />
            {/* Elegant Custom Hover Mask */}
            <div 
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.45)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontSize: "11px",
                fontWeight: "700",
                borderRadius: "6px",
                opacity: 0,
                transition: "opacity 0.2s ease"
              }}
              onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
              onMouseLeave={(e) => e.currentTarget.style.opacity = 0}
            >
              VIEW
            </div>
          </div>
        ),
        action: (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
            }}
          >
            {" "}
            <Button
              onClick={() => this.editInAIArticle(video._id)}
              style={{ marginRight: "10px", backgroundColor: "#5C1D10", color: "#fff", border: "none" }}
            >
              AI Edit
            </Button>{" "}
            <br />
            <DeleteVideo articles={true} video={video} />
          </div>
        ),
      }));
      const stateUpdates = {
        videos,
        totalPages: data.articles.totalDocs,
        currentPage: data.articles.page,
      };
      if (this.state.statusFilter === "Draft") {
        stateUpdates.draftsCount = data.articles.totalDocs || 0;
      }
      this.setState(stateUpdates);
    } catch (err) {
      if (err.response) {
        return message.error(err.response.data.message);
      }
      return message.error(err.message);
    }
  };
  onEditClick = (e, data) => {
    e.stopPropagation();

    this.setState({
      editData: data,
      text: "Edit",
      main: !this.state.main,
    });
  };
  onPageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      this.getArticles(this.state.currentPage);
    });
  };

  componentDidMount() {
    const editArticle = this.props.editArticle;
    if (editArticle && typeof editArticle.statusFilter !== "undefined") {
      this.setState({ statusFilter: editArticle.statusFilter }, () => {
        this.getArticles(1);
        if (this.props.clearEditArticle) {
          this.props.clearEditArticle();
        }
      });
    } else {
      this.getArticles(1);
    }
    this.fetchDraftsCount();
  }

  fetchDraftsCount = async () => {
    try {
      const data = await getArticles(
        {
          status: "Draft",
          pageNo: 1,
        },
        this.props.Auth.user.token
      );
      if (data && data.articles) {
        this.setState({ draftsCount: data.articles.totalDocs || 0 });
      }
    } catch (err) {
      console.error("Failed to fetch drafts count:", err);
    }
  };
  rowClickHandler = (video) => {
    this.setState({ playingVideo: video, isVideoPlayerOpen: true });
  };
  changeProvince = (province) => {
    this.setState({ province });
  };
  handleChangeTags = (tags) => {
    this.setState({ tags });
  };
  handleAddNewParagraph = () => {
    const { descriptionWithImage } = this.state;
    descriptionWithImage.push({ imageUrl: "", paragraph: "" });
    this.setState({ descriptionWithImage });
  };
  handleRemoveParagraph = (index) => {
    const { descriptionWithImage } = this.state;
    try {
      if (descriptionWithImage.length < 2) return;
      descriptionWithImage.splice(index, 1);
      this.setState({ descriptionWithImage });
    } catch (err) { }
  };

  handleImagesParagraph = (image, index) => {
    const { descriptionWithImage } = this.state;
    try {
      descriptionWithImage[index].imageUrl = image;
      this.setState({ descriptionWithImage });
    } catch (err) { }
  };
  render() {
    const {
      videos,
      totalPages,
      currentPage,
      isVideoPlayerOpen,
      video,
      isEditFormLoading,
      playingVideo,
      title,
      description,
      isModalOpen,
      isFormLoading,
      thumbnail,
      removeThumbnailofParagraph,
      thumbnailUrl,
      selectedCategory,
      shortDescription,
      descriptionWithImage,
      tags,
    } = this.state;

    const { Title } = Typography;

    return (
      <div>
        {/* Custom Premium Centered Lightbox Image Preview Modal */}
        {this.state.isPreviewOpen && (
          <div 
            onClick={() => this.setState({ isPreviewOpen: false })}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(15, 23, 42, 0.85)",
              backdropFilter: "blur(12px)",
              zIndex: 1000000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              animation: "fadeIn 0.2s ease"
            }}
          >
            <style>{`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              @keyframes zoomIn {
                from { transform: scale(0.9) translateY(10px); opacity: 0; }
                to { transform: scale(1) translateY(0); opacity: 1; }
              }
            `}</style>
            <div 
              onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside image card
              style={{ 
                position: "relative", 
                maxWidth: "90vw", 
                maxHeight: "85vh",
                animation: "zoomIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)"
              }}
            >
              <img 
                src={this.state.previewImageUrl} 
                alt="Preview" 
                style={{
                  maxWidth: "100%",
                  maxHeight: "85vh",
                  borderRadius: "16px",
                  boxShadow: "0 25px 50px -12px rgba(0,0,0,0.6)",
                  border: "4px solid white",
                  objectFit: "contain"
                }} 
              />
              {/* Elegant Close Button */}
              <button
                onClick={() => this.setState({ isPreviewOpen: false })}
                style={{
                  position: "absolute",
                  top: "-15px",
                  right: "-15px",
                  background: "#5C1D10",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: "36px",
                  height: "36px",
                  cursor: "pointer",
                  fontSize: "20px",
                  fontWeight: "bold",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "transform 0.2s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
              >
                &times;
              </button>
            </div>
          </div>
        )}
        {!this.state.main ? (
          <AddArticlesScreen
            text={this.state.text}
            editData={this.state.editData}
            open={() => this.openVideoForm()}
          />
        ) : (
          <>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <div className="p-0.5 md:p-5">
                  <Card>
                    <div className="flex-between">
                      <div style={{ width: "100%" }}>
                        <Row gutter={[12, 12]}>
                          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <div className="flex-col">
                              <Title level={2} className="mb-0 text-primary" style={{ height: "50px", lineHeight: "50px", whiteSpace: "nowrap" }}>All News and Article</Title>
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                            <div className="flex-col">
                              <Title level={4} className="mb-0 text-primary">Status Filter</Title>
                              <div style={{
                                display: "flex",
                                background: "#f1f5f9",
                                padding: "4px",
                                borderRadius: "10px",
                                border: "1px solid #e2e8f0",
                                width: "100%",
                                height: "38px",
                                boxSizing: "border-box"
                              }}>
                                <button
                                  type="button"
                                  onClick={() => this.setState({ statusFilter: "" }, () => this.getArticles(1))}
                                  style={{
                                    flex: 1,
                                    border: "none",
                                    background: this.state.statusFilter === "" ? "#ffffff" : "transparent",
                                    color: this.state.statusFilter === "" ? "#fb6222" : "#64748b",
                                    borderRadius: "8px",
                                    fontSize: "12.5px",
                                    fontWeight: "800",
                                    cursor: "pointer",
                                    boxShadow: this.state.statusFilter === "" ? "0 2px 6px rgba(0,0,0,0.06)" : "none",
                                    transition: "all 0.2s ease"
                                  }}
                                >
                                  All
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    if (this.props.setSelected) {
                                      this.props.setSelected("Drafts");
                                    }
                                  }}
                                  style={{
                                    flex: 1,
                                    border: "none",
                                    background: this.state.statusFilter === "Draft" ? "#ffffff" : "transparent",
                                    color: this.state.statusFilter === "Draft" ? "#fb6222" : "#64748b",
                                    borderRadius: "8px",
                                    fontSize: "12.5px",
                                    fontWeight: "800",
                                    cursor: "pointer",
                                    boxShadow: this.state.statusFilter === "Draft" ? "0 2px 6px rgba(0,0,0,0.06)" : "none",
                                    transition: "all 0.2s ease"
                                  }}
                                >
                                  Drafts
                                </button>
                              </div>
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                            <div className="flex-col">
                              <Title level={4} className="mb-0 text-primary">Search Text</Title>
                              <Input
                                placeholder="Search..."
                                value={this.state.searchQuery}
                                onChange={(e) => {
                                  const searchQuery = e.target.value;
                                  if (this.state.typingTimeout) {
                                    clearTimeout(this.state.typingTimeout);
                                  }

                                  this.setState({
                                    searchQuery: searchQuery,
                                    typingTimeout: setTimeout(() => {
                                      this.getArticles(this.state.currentPage);
                                    }, 1000),
                                  });
                                }}
                                style={{ width: "100%" }}
                              />
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                            <div className="flex-col">
                              <Title level={4} className="mb-0 text-primary">Select Category</Title>
                              <CategoryDropDown
                                category={this.state.getArticlesFilterCategory}
                                categoriesOptions={NewsEnum}
                                setCategory={this.onVideoCategoryChange}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>

                    </div>
                  </Card>
                </div>
              </Col>

              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <div className="">
                  <Table
                    onRowClick={this.rowClickHandler}
                    data={videos}
                    columns={columns}
                  />
                </div>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <div className="p-0.5 md:p-5" style={{ display: "flex", justifyContent: "center" }}>
                  <Pagination
                    current={currentPage}
                    total={totalPages}
                    onPageChange={this.onPageChange}
                  />
                </div>
              </Col>
            </Row>
          </>
        )}
        {/* <VideoPlayer
          videoTitle={playingVideo && playingVideo.title}
          closePlayer={this.closeVideoPlayer}
          isPlayerOpen={isVideoPlayerOpen}
          url={
            playingVideo &&
            `${videoUrl}?videoId=${playingVideo._id}&customerId=${this.props.Auth.user._id}`
          }
        /> */}
        {/* <AddVideo
          title={title}
          category={selectedCategory}
          setCategory={this.onAddCategoryChange}
          categoriesOptions={NewsEnum}
          closeModal={this.closeVideoForm}
          description={descriptionWithImage}
          inputHandler={this.inputChangeHandler}
          inputChangeDiscription={this.inputChangeDiscription}
          selectVideo={this.selectVideo}
          video={video}
          isOpen={isModalOpen}
          tags={tags}
          removeThumbnailofParagraph={removeThumbnailofParagraph}
          uploadThumbnail={this.uploadThumbnail}
          shortDescription={shortDescription}
          isNotShow={false}
          handleChangeTags={this.handleChangeTags}
          isFormLoading={isFormLoading}
          submitVideo={this.submitVideo}
          selectThumbnail={this.selectThumbnail}
          thumbnail={thumbnail}
          uploadedPercentage={this.state.uploadedPercentage}
          handleImagesParagraph={this.handleImagesParagraph}
          handleAddNewParagraph={this.handleAddNewParagraph}
          handleRemoveParagraph={this.handleRemoveParagraph}
          uploadThumbnailofParagraph={this.uploadThumbnailofParagraph}
        /> */}
        {
          // !this.state.isModalOpen ?
          //   <AddVideo
          //     title={title}
          //     isNotShow={false}
          //     category={selectedCategory}
          //     thumbnailUrl={thumbnailUrl}
          //     handleImagesParagraph={this.handleImagesParagraph}
          //     thumbnail={thumbnail}
          //     setCategory={this.onAddCategoryChange}
          //     categoriesOptions={NewsEnum}
          //     closeModal={this.closeVideoEditFrom}
          //     uploadThumbnail={this.uploadThumbnail}
          //     description={descriptionWithImage}
          //     inputChangeDiscription={this.inputChangeDiscription}
          //     shortDescription={shortDescription}
          //     inputHandler={this.inputChangeHandler}
          //     selectVideo={this.selectVideo}
          //     removeThumbnailofParagraph={removeThumbnailofParagraph}
          //     video={video}
          //     isOpen={this.state.isModalEdit}
          //     handleChangeTags={this.handleChangeTags}
          //     isFormLoading={isEditFormLoading}
          //     submitVideo={this.videoEditSubmit}
          //     selectThumbnail={this.selectThumbnail}
          //     thumbnail={thumbnail}
          //     uploadedPercentage={this.state.uploadedPercentage}
          //     handleAddNewParagraph={this.handleAddNewParagraph}
          //     handleRemoveParagraph={this.handleRemoveParagraph}
          //     uploadThumbnailofParagraph={this.uploadThumbnailofParagraph}
          //   />
          //   :
        }
      </div>
    );
  }
}
const mapStateToProps = (store) => ({
  Auth: store.Authentication,
});
export default connect(mapStateToProps)(Body);
